export default __webpack_public_path__ + "static/acai2-919b3f159c5bab321acf94ec946fd0ad.png";